
<ng-container *ngIf="activated">
  <ng-container *ngIf="hasFilterList; then filterListTemplate; else listOnlyTemplate"></ng-container>
</ng-container>

<!-- LIST WITH FILTER LIST -->
<ng-template #filterListTemplate>
  <div [ngClass]="'lm-list-container'"
       soho-busyindicator
       [text]="' '"
       [blockUI]="true"
       [displayDelay]="20"
       [timeToComplete]="this.uiLoadingIndicatorTimeout"
       [transparentOverlay]="false">
  <div class="list-detail two-column fixed-sm">
    <aside class="sidebar">
      <div class="sidebar-content lm-filter-list-container">
        <lm-list #filterListComponent
            [listUrlInfo]="filterListUrlInfo"
            [listSpec]="filterListSpec"
            [fromDataView]="fromDataView"

            (contentModified)="onContentModified($event)"
            (listRowSelected)="onFilterListRowSelected($event)"
            (listDisplayed)="onFilterListDisplayed($event)"
            (busyIndicatorDisplayedEvent)="onBusyIndicatorDisplayed($event)"
        ></lm-list>
      </div>
    </aside>

    <div class="main">
      <div class="main-content filterlist-content-area">
        <!-- begin content area -->
        <lm-list #listComponent
            [listUrlInfo]="listUrlInfo"
            [listSpec]="listSpec"
            [fromDataView]="filterListFilterCriteria ? fromDataView : null"
            [filterListFilterCriteria]="filterListFilterCriteria"
            [hasFilterList]="true"
            [implementsDragAndDrop]="implementsDragAndDrop"

            (listDisplayed)="onListDisplayed($event)"
            (listDragDropEvent)="onListDragDropEvent($event)"
            (listTransactionEvent)="onListTransactionEvent($event)"
            (busyIndicatorDisplayedEvent)="onBusyIndicatorDisplayed($event)"
        ></lm-list>
      </div>
    </div>
  </div>
</div>
</ng-template>

<!-- LIST ONLY  -->
<ng-template #listOnlyTemplate>
  <div [ngClass]="'lm-list-container'">
    <lm-list #listComponent
        [listUrlInfo]="listUrlInfo"
        [listSpec]="listSpec"
        [fromDataView]="fromDataView"
        [implementsManualLoad]="panel.implementsManualLoad"
        [manualLoadInfo]="panel.manualLoadInfo"

        (contentModified)="onContentModified($event)"
        (listDisplayed)="onListDisplayed($event)"
        (sendContextMessageEvent)="onSendContextMessageEvent($event)"
        (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
        (listTransactionEvent)="onListTransactionEvent($event)"
        (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)"
    ></lm-list>
  </div>
</ng-template>
